import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "c-bg--gray p-the-page-h01 c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "c-common-inner" }
const _hoisted_4 = { class: "p-the-page-h01__inner" }
const _hoisted_5 = { class: "p-the-page-h01__header" }
const _hoisted_6 = { class: "p-the-page-h01__profile" }
const _hoisted_7 = { class: "p-the-page-h01__notification" }
const _hoisted_8 = { class: "c-common-inner" }
const _hoisted_9 = { class: "p-the-page-h01__forms" }
const _hoisted_10 = { class: "p-the-page-h01__forms__sort" }
const _hoisted_11 = { class: "p-the-page-h01__forms__sort__item" }
const _hoisted_12 = { class: "p-the-page-h01__error-message" }
const _hoisted_13 = { class: "p-the-page-h01-list" }
const _hoisted_14 = {
  key: 0,
  class: "p-the-page-h01__footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheBreadcrumb = _resolveComponent("TheBreadcrumb")!
  const _component_CommonHeading = _resolveComponent("CommonHeading")!
  const _component_TheH01ProfilePanel = _resolveComponent("TheH01ProfilePanel")!
  const _component_TheH01Notification = _resolveComponent("TheH01Notification")!
  const _component_ButtonRefine = _resolveComponent("ButtonRefine")!
  const _component_FormSearch = _resolveComponent("FormSearch")!
  const _component_ValidationErrorText = _resolveComponent("ValidationErrorText")!
  const _component_H01PointConfirmItem = _resolveComponent("H01PointConfirmItem")!
  const _component_PageNavi = _resolveComponent("PageNavi")!
  const _component_FloatingGivePointButton = _resolveComponent("FloatingGivePointButton")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TheHeader, { ref: "theHeader" }, null, 512),
      _createElementVNode("div", {
        style: _normalizeStyle({ backgroundColor: _ctx.lightColorCode })
      }, [
        _createVNode(_component_TheBreadcrumb, { class: "p-the-header-breadcrumb-area" })
      ], 4),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_CommonHeading, { class: "p-the-page-h01__confirmation-title" }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("ポイント確認", -1)
              ])),
              _: 1,
              __: [7]
            }),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_TheH01ProfilePanel, {
                "light-color-code": _ctx.lightColorCode,
                "show-button": true
              }, null, 8, ["light-color-code"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_TheH01Notification)
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "p-the-page-h01__body",
        style: _normalizeStyle({ backgroundColor: _ctx.lightColorCode })
      }, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_CommonHeading, { class: "p-the-page-h01__history-title" }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode("ポイント履歴", -1)
            ])),
            _: 1,
            __: [8]
          }),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "p-the-page-h01__forms__refine",
              style: _normalizeStyle({ '--h01-refine-color': _ctx.colorCode })
            }, [
              _createVNode(_component_ButtonRefine, {
                refine: _ctx.refine.target,
                "onUpdate:refine": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.refine.target) = $event)),
                heading: _ctx.refineHeading,
                icon: "arrow",
                "icon-color": "#ffffff",
                "refine-item-list": _ctx.computedItemList,
                shown: _ctx.refine.shownState,
                width: "auto",
                onDoSort: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doRefine($event))),
                onSwitchRefineState: _ctx.switchRefineState
              }, null, 8, ["refine", "heading", "refine-item-list", "shown", "onSwitchRefineState"])
            ], 4),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_ButtonRefine, {
                  refine: _ctx.sorted.target,
                  "onUpdate:refine": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sorted.target) = $event)),
                  heading: _ctx.filterHeading,
                  icon: "sorted",
                  "refine-item-list": _ctx.sorted.itemList,
                  shown: _ctx.sorted.shownState,
                  width: "110px",
                  onDoSort: _cache[3] || (_cache[3] = ($event: any) => (_ctx.doSort($event))),
                  onSwitchRefineState: _ctx.switchSortedState
                }, null, 8, ["refine", "heading", "refine-item-list", "shown", "onSwitchRefineState"])
              ])
            ]),
            _createElementVNode("div", {
              class: "p-the-page-h01__forms__search",
              onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createVNode(_component_FormSearch, {
                search: _ctx.search,
                "onUpdate:search": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.search) = $event)),
                "icon-color": "#000000",
                onDoSearch: _cache[5] || (_cache[5] = ($event: any) => (_ctx.doSearch()))
              }, null, 8, ["search"]),
              _createElementVNode("div", null, [
                _withDirectives(_createVNode(_component_ValidationErrorText, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.error), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.error]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.errorMessage), 1)
          ]),
          _createElementVNode("ul", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historyList, ({
                  name,
                  icon,
                  unread,
                  group,
                  point_status,
                  date,
                  url,
                  key,
                  icon_type
                }) => {
              return (_openBlock(), _createElementBlock("li", {
                key: key,
                class: "p-the-page-h01-list__item"
              }, [
                _createVNode(_component_H01PointConfirmItem, {
                  "icon-path": icon,
                  unread: unread,
                  name: name,
                  group: group,
                  date: date,
                  usage: point_status.usage,
                  status: point_status.usage_label,
                  approved: point_status.approved,
                  label: point_status.annotation_label,
                  "label-type": point_status.annotation_type,
                  point: point_status.point,
                  sign: point_status.point_addition,
                  url: url,
                  "approved-enabled": _ctx.approvedEnabled,
                  "icon-type": icon_type
                }, null, 8, ["icon-path", "unread", "name", "group", "date", "usage", "status", "approved", "label", "label-type", "point", "sign", "url", "approved-enabled", "icon-type"])
              ]))
            }), 128))
          ]),
          (_ctx.historyList.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_PageNavi, {
                  "current-page": _ctx.pageNavi.currentPage,
                  "next-page-url": _ctx.pageNavi.nextPageUrl,
                  "prev-page-url": _ctx.pageNavi.prevPageUrl,
                  "max-page": _ctx.pageNavi.maxPage,
                  "base-url": _ctx.pageNavi.baseUrl
                }, null, 8, ["current-page", "next-page-url", "prev-page-url", "max-page", "base-url"])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 4)
    ]),
    _createVNode(_component_FloatingGivePointButton),
    _createVNode(_component_TheFooter)
  ]))
}